// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingCancelLimitPanel_root__1cBp9","form":"EditListingCancelLimitPanel_form__3eigz","title":"EditListingCancelLimitPanel_title__3KyTd"};